/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_EyebrowInputs */

const en_site_eyebrow = /** @type {(inputs: Site_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open RMF · Web demo`)
};

const fr_site_eyebrow = /** @type {(inputs: Site_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open RMF · Démo web`)
};

const ms_sg2_site_eyebrow = /** @type {(inputs: Site_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open RMF · Demo Web`)
};

/**
* | output |
* | --- |
* | "Open RMF · Web demo" |
*
* @param {Site_EyebrowInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const site_eyebrow = /** @type {((inputs?: Site_EyebrowInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_EyebrowInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_eyebrow(inputs)
	if (locale === "fr") return fr_site_eyebrow(inputs)
	return ms_sg2_site_eyebrow(inputs)
});